module.exports = __webpack_public_path__ + "img/download.8b7e841c.svg";